import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class ChangePasswordService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    public changePasswordRequest(pwd){
        let serviceUrl = this.baseUrl + 'OnBoardService/changePassword';
        return this.http.post<any>(serviceUrl,pwd).pipe(map(response => {return response;}));
    }

    public updatePasswordRequest(pwd){
        let serviceUrl = this.baseUrl + 'RegistrationService/updatePassword';
        return this.http.post<any>(serviceUrl,pwd).pipe(map(response => {return response;}));
    }

    getRules(): Observable<any> {

        let rules = [{
            "id": 1,
            "name": "alreadyUsed",
            "description": "This password is already used in the past",
            "value": null,
            "regex": null,
            "message": "already used",
            "active": true
        }, {
            "id": 3,
            "name": "minChars",
            "description": "Minimum x characters long",
            "value": "10",
            "regex": "^.{10,}$",
            "message": "Min 10 characters long",
            "active": true
         } , {
            "id": 4,
            "name": "maxChars",
            "description": "Maximum x characters long",
            "value": "32",
            "regex": "^.{0,32}$",
            "message": "Max 32 characters long",
            "active": true
         } , 
        // {
        //     "id": 4,
        //     "name": "minDigits",
        //     "description": "at least x digits",
        //     "value": "3",
        //     "regex": "(.*\\d.*){3}",
        //     "message": "at least 3 digits",
        //     "active": false
        // }, {
        //     "id": 7,
        //     "name": "exitsLowerCaseLetter",
        //     "description": "at least one lower case letter",
        //     "value": null,
        //     "regex": "(.*[a-z].*)+",
        //     "message": "at least one lower case letter",
        //     "active": false
        // }, 
        {
            "id": 8,
            "name": "exitsUpperCaseLetter",
            "description": "at least one upper case letter",
            "value": null,
            "regex": "(.*[A-Z].*)+",
            "message": "Min One Upper case alphabet",
            "active": true
        }, {
            "id": 9,
            "name": "exitsDigit",
            "description": "at least one digit",
            "value": null,
            "regex": "(.*\\d.*)+",
            "message": "Min One numeric character",
            "active": true
        }, {
            "id": 10,
            "name": "exitsSpecialChar",
            "description": "at least one special character",
            "value": null,
            "regex": "(.*[-+=_.,:;~`?|!@#$%^&*(){}<>\\[\\]\"'\\/\\\\].*)+",
            "message": "Min One Special character like *, !,@,$,#_",
            "active": true
        },{
            "id": 11,
            "name": "existsSpace",
            "description": "No blank spaces",
            "value": null,
            "regex": "^[^' ']+$",
            "message": "No blank spaces",
            "active": true
        }]

        return of(rules);
        
        let serviceUrl = this.baseUrl + 'LoginService/rules';
        return this.http.get(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));
    }
}